<template>
    <div>
        <div class="laddressFirst">
            <div class="laddressFirstLeft">编辑发票抬头</div>
            <div class="laddressFirstBtn" @click="Return()">返回</div>
        </div>
        <div class="changePasswordForm">
            <Form ref="formCustoms" :model="formCustom" :rules="ruleCustom" :label-width="155">
                <FormItem label="开票类型" prop="city">
                    <Select v-model="formCustom.city" placeholder="请输入开票类型">
                        <!-- <Option value="个人普票">个人普票</Option> -->
                        <Option :value="2">增值税普通发票</Option>
                        <Option :value="3">增值税专用发票</Option>
                    </Select>
                </FormItem>
                <FormItem label="名称" prop="invoiceRise">
                    <Input type="text" placeholder="请输入名称" v-model="formCustom.invoiceRise"></Input>
                </FormItem>
                <FormItem label="纳税人识别号" prop="identifyNumber">
                    <Input type="text" placeholder="请输入纳税人识别号" v-model="formCustom.identifyNumber"></Input>
                </FormItem>
                <!-- <FormItem v-if="formCustom.city == 3" label="地址、电话" prop="address">
                    <Input type="text" placeholder="请输入地址、电话" v-model="formCustom.address"></Input>
                </FormItem> -->
                <!-- <FormItem v-if="formCustom.city == 3" label="开户行及账号" prop="bankBranchName">
                    <Input type="text" placeholder="请输入开户行及账号" v-model="formCustom.bankBranchName"></Input>
                </FormItem> -->
                <FormItem v-if="formCustom.city != 3" label="接收邮箱">
                    <Input type="text" placeholder="请输入接收邮箱" v-model="formCustom.email"></Input>
                </FormItem>
                <FormItem v-if="formCustom.city == 3" label="邮寄地址" prop="bankAccount">
                    <Select v-model="formCustom.bankAccount" placeholder="请选择邮寄地址" @on-change="bankChange">
                        <Option v-for="item in data1" :key="item.id" :value="item.site">{{item.site}}</Option>
                    </Select>
                </FormItem>
                <FormItem  label="联系方式" prop="mobile">
                    <Input type="text" placeholder="请输入联系方式" v-model="formCustom.mobile"></Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="Submit()">提交</Button>
                </FormItem>
            </Form>
        </div>
    </div>
</template>
<script>
    import Cookies from "js-cookie";
    import {
        editInvoice,
        getAddress
    } from "../../../network/LPersonal";
    export default {
        data() {
            const validatePass = (rule, value, callback) => {
                if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value))) {
                    callback(new Error('请输入正确的手机号'));
                } else {
                    callback();
                }
            };
            const email = (rule, value, callback) => {
                if (!(/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value))) {
                    callback(new Error('请输入正确的邮箱'));
                } else {
                    callback();
                }
            };
            const validateNumber = (rule, value, callback) => {
                if (!(/^[A-Z0-9]{6,20}$/.test(value))) {
                    callback(new Error('请输入正确的税号'));
                } else {
                    callback();
                }
            };
            return {
                obj: {},
                formCustom: {
                    identifyNumber: "",
                    newaddress: "",
                    youbian: "",
                    city: "普通发票",
                    isDefault: "",
                    id: "",
                },
                ruleCustom: {
                    invoiceRise: [{
                        required: true,
                        message: "请输入发票抬头",
                        trigger: "blur"
                    }, ],
                    identifyNumber: [{
                        required: true,
                        validator: validateNumber,
                        message: "请输入正确的税号，6-20位数字和大写字母",
                        trigger: "blur",
                    }, ],
                    address: [{
                        required: false,
                        message: "请输入地址/手机号",
                        trigger: "blur"
                    }, ],
                    mobile: [{
                        required: true,
                        validator: validatePass,
                        trigger: "change"
                    }, ],
                    bankBranchName: [{
                        required: false,
                        message: "请输入开户行名称/开户账号",
                        trigger: "blur"
                    }, ],
                    bankAccount: [{
                        required: false,
                        message: "请输入专票邮寄地址",
                        trigger: "change",
                        type: 'string'
                    }, ],
                    city: [{
                        required: true,
                        type: 'number',
                        message: "请选择开票类型",
                        trigger: "change",
                    }, ],
                    email: [{
                        required: true,
                        validator: email,
                        trigger: "blur",
                    }, ],
                },
                type: 0,
                data1: [],
            };
        },
        mounted() {
            this.obj = JSON.parse(decodeURIComponent(this.$route.query.data));
            this.$set(this.formCustom, 'invoiceRise', this.obj.invoiceRise)
            this.$set(this.formCustom, 'id', this.obj.id)
            this.$set(this.formCustom, 'identifyNumber', this.obj.identifyNumber)
            this.$set(this.formCustom, 'address', this.obj.address)
            this.$set(this.formCustom, 'city', this.obj.invoiceType)
            this.$set(this.formCustom, 'email', this.obj.email)
            this.$set(this.formCustom, 'bankBranchName', this.obj.bankBranchName)
            this.$set(this.formCustom, 'bankAccount', this.obj.bankAccount)
            this.$set(this.formCustom, 'mobile', this.obj.mobile)
            console.log(this.formCustom.invoiceType, typeof(this.formCustom.invoiceType))
            this.formCustom.isDefault = this.obj.isDefault == true ? 1 : 0;
            this.formCustom.invoiceType = this.obj.invoiceType;
            
            let from = {
                userId: this.Get("userId"),
            };
            getAddress(from).then((res) => {
                console.error(res,'getAddressgetAddressgetAddressgetAddress');
                res.data.data.forEach(f => {
                    f.site = f.province + f.city + f.county+f.address
                })
                this.data1 = res.data.data;
            });
        },
        methods: {

            bankChange() {
                this.data1.forEach(e => {
                    if(e.site === this.formCustom.bankAccount) {
                        this.$set(this.formCustom,'mobile',e.mobile)
                        this.$forceUpdate();
                    }
                })
                console.log(typeof(this.formCustom.mobile), typeof(this.formCustom.bankAccount) );
            },
            Get(name) {
                return Cookies.get(`admin-${name}`);
            },
            Return() {
                this.$router.go(-1);
            },
            Submit() {
                if (this.formCustom.city == 2) {
                    this.type = 0;
                } else {
                    this.type = 1;
                }
                this.$refs.formCustoms.validate((valid) => {
                    if (valid) {
                        if(this.formCustom.email){
                            if(!(/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(this.formCustom.email))){
                                this.$message.error('请填写正确邮箱');
                                return
                            }
                        }
                        this.editInvoice()
                    }
                    else{
                        this.$message.error('请输入完整信息');
                    }
                })
            },
            editInvoice() {
                editInvoice({
                    identifyNumber: this.formCustom.identifyNumber,
                    invoiceRise: this.formCustom.invoiceRise,
                    invoiceType: this.formCustom.city,
                    userId: this.Get("userId"),
                    id: this.formCustom.id,
                    isDefault: this.formCustom.isDefault,
                    address: this.formCustom.address,
                    mobile: this.formCustom.mobile,
                    bankBranchName: this.formCustom.bankBranchName,
                    bankAccount: this.formCustom.bankAccount,
                    email: this.formCustom.email
                }).then((r) => {
                    if (r.data.code == 200) {
                        this.$message.success(r.data.msg);
                        this.$router.go(-1)
                    } else {
                        this.$message.error(r.data.msg);
                    }
                });
            },
        },
    };
</script>
<style scoped>
</style>